const sortOptions = {
  recentlyUpdated: {
    text: 'Recently Updated',
    value: 'lastModifiedDate',
    order: 'desc',
  },
  dispatchedDate: {
    text: 'Dispatched Date',
    value: 'dateDispatched',
    order: 'desc',
  },
};
export default sortOptions;
